import Vue from 'vue'
import { abilitiesPlugin, Can } from '@casl/vue'
import ability from '../../utils/permissions/defineAbility'

Vue.use(abilitiesPlugin, ability)
Vue.component('Can', Can)
